(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6577],{

/***/ 15349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ FlatList; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59740);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_native_web_dist_exports_FlatList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98362);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82075);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41580);
/* harmony import */ var _utils_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69232);
/* harmony import */ var _hooks_useHasResponsiveProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87166);
var _excluded=["_contentContainerStyle","contentContainerStyle"];function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}var StyledFlatList=(0,_utils_styled__WEBPACK_IMPORTED_MODULE_1__/* .makeStyledComponent */ .R)(react_native_web_dist_exports_FlatList__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);var FlatListComponent=function FlatListComponent(props,ref){var _usePropsResolution=(0,_hooks__WEBPACK_IMPORTED_MODULE_3__/* .usePropsResolution */ .n)("FlatList",props),_contentContainerStyle=_usePropsResolution._contentContainerStyle,contentContainerStyle=_usePropsResolution.contentContainerStyle,resolvedProps=(0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_usePropsResolution,_excluded);var resolved_ContentContainerStyle=(0,_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useStyledSystemPropsResolver */ .t)(_contentContainerStyle||{});if((0,_hooks_useHasResponsiveProps__WEBPACK_IMPORTED_MODULE_6__/* .useHasResponsiveProps */ .M)(props)){return null;}return react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledFlatList,_extends({},resolvedProps,{contentContainerStyle:contentContainerStyle||resolved_ContentContainerStyle,ref:ref}));};var FlatList=(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(FlatListComponent);

/***/ }),

/***/ 7676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ ScrollView; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59740);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_native_web_dist_exports_ScrollView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93133);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82075);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41580);
/* harmony import */ var _utils_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69232);
/* harmony import */ var _hooks_useHasResponsiveProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87166);
var _excluded=["_contentContainerStyle","contentContainerStyle"];function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}var StyledScrollView=(0,_utils_styled__WEBPACK_IMPORTED_MODULE_1__/* .makeStyledComponent */ .R)(react_native_web_dist_exports_ScrollView__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);var ScrollView=(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(props,ref){var _usePropsResolution=(0,_hooks__WEBPACK_IMPORTED_MODULE_3__/* .usePropsResolution */ .n)("ScrollView",props,{}),_contentContainerStyle=_usePropsResolution._contentContainerStyle,contentContainerStyle=_usePropsResolution.contentContainerStyle,resolvedProps=(0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_usePropsResolution,_excluded);var resolved_ContentContainerStyle=(0,_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useStyledSystemPropsResolver */ .t)(_contentContainerStyle||{});if((0,_hooks_useHasResponsiveProps__WEBPACK_IMPORTED_MODULE_6__/* .useHasResponsiveProps */ .M)(props)){return null;}return react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledScrollView,_extends({},resolvedProps,{contentContainerStyle:contentContainerStyle||resolved_ContentContainerStyle,ref:ref}));});

/***/ }),

/***/ 39388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ primitives_Button_Button; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Spinner/index.js
var Spinner = __webpack_require__(57787);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/hooks/useThemeProps/usePropsResolution.js + 4 modules
var usePropsResolution = __webpack_require__(82075);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Box/index.js + 2 modules
var Box = __webpack_require__(4934);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Stack/HStack.js
var HStack = __webpack_require__(79305);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Pressable/Pressable.js
var Pressable = __webpack_require__(5621);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/utils/mergeRefs.js
var mergeRefs = __webpack_require__(42568);
// EXTERNAL MODULE: ../../node_modules/@react-native-aria/focus/lib/module/index.web.js + 1 modules
var index_web = __webpack_require__(11247);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/hooks/useHasResponsiveProps.js
var useHasResponsiveProps = __webpack_require__(87166);
;// CONCATENATED MODULE: ../../node_modules/native-base/lib/module/components/primitives/Button/Button.js
var _excluded=["children","startIcon","rightIcon","leftIcon","endIcon","spinner","isDisabled","isLoading","isHovered","isPressed","isFocused","isFocusVisible","spinnerPlacement"],_excluded2=["onPressIn","onPressOut","onHoverIn","onHoverOut","onFocus","onBlur","_text","_stack","_spinner","isLoadingText","_icon"];function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){(0,defineProperty/* default */.Z)(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}var Button=function Button(param,ref){var children=param.children,startIcon=param.startIcon,rightIcon=param.rightIcon,leftIcon=param.leftIcon,endIcon=param.endIcon,spinner=param.spinner,isDisabled=param.isDisabled,isLoading=param.isLoading,isHoveredProp=param.isHovered,isPressedProp=param.isPressed,isFocusedProp=param.isFocused,isFocusVisibleProp=param.isFocusVisible,_param$spinnerPlaceme=param.spinnerPlacement,spinnerPlacement=_param$spinnerPlaceme===void 0?"start":_param$spinnerPlaceme,props=(0,objectWithoutProperties/* default */.Z)(param,_excluded);var _props$accessibilityR;var _useHover=(0,Pressable/* useHover */.XI)(),hoverProps=_useHover.hoverProps,isHovered=_useHover.isHovered;var _useIsPressed=(0,Pressable/* useIsPressed */.VU)(),pressableProps=_useIsPressed.pressableProps,isPressed=_useIsPressed.isPressed;var _useFocus=(0,Pressable/* useFocus */.KK)(),focusProps=_useFocus.focusProps,isFocused=_useFocus.isFocused;var _useFocusRing=(0,index_web/* useFocusRing */.Fx)(),isFocusVisible=_useFocusRing.isFocusVisible,focusRingProps=_useFocusRing.focusProps;var _usePropsResolution=(0,usePropsResolution/* usePropsResolution */.n)("Button",props,{isDisabled:isDisabled,isHovered:isHoveredProp||isHovered,isFocused:isFocusedProp||isFocused,isPressed:isPressedProp||isPressed,isLoading:isLoading,isFocusVisible:isFocusVisibleProp||isFocusVisible}),onPressIn=_usePropsResolution.onPressIn,onPressOut=_usePropsResolution.onPressOut,onHoverIn=_usePropsResolution.onHoverIn,onHoverOut=_usePropsResolution.onHoverOut,onFocus=_usePropsResolution.onFocus,onBlur=_usePropsResolution.onBlur,_text=_usePropsResolution._text,_stack=_usePropsResolution._stack,_spinner=_usePropsResolution._spinner,isLoadingText=_usePropsResolution.isLoadingText,_icon=_usePropsResolution._icon,resolvedProps=(0,objectWithoutProperties/* default */.Z)(_usePropsResolution,_excluded2);if((0,useHasResponsiveProps/* useHasResponsiveProps */.M)(props)){return null;}if(leftIcon){startIcon=leftIcon;}if(rightIcon){endIcon=rightIcon;}if(endIcon&&react.isValidElement(endIcon)){endIcon=react.Children.map(endIcon,function(child,index){return react.cloneElement(child,_objectSpread(_objectSpread({key:"button-end-icon-".concat(index)},_icon),child.props));});}if(startIcon&&react.isValidElement(startIcon)){startIcon=react.Children.map(startIcon,function(child,index){return react.cloneElement(child,_objectSpread(_objectSpread({key:"button-start-icon-".concat(index)},_icon),child.props));});}var spinnerElement=spinner?spinner:react.createElement(Spinner/* default */.Z,_extends({color:_text===null||_text===void 0?void 0:_text.color},_spinner));var boxChildren=function boxChildren(child){return child?react.createElement(Box/* default */.Z,{_text:_text},child):null;};return react.createElement(Pressable/* default */.ZP,_extends({disabled:isDisabled||isLoading,ref:ref,onPressIn:(0,mergeRefs/* composeEventHandlers */.M)(onPressIn,pressableProps.onPressIn),onPressOut:(0,mergeRefs/* composeEventHandlers */.M)(onPressOut,pressableProps.onPressOut),onHoverIn:(0,mergeRefs/* composeEventHandlers */.M)(onHoverIn,hoverProps.onHoverIn),onHoverOut:(0,mergeRefs/* composeEventHandlers */.M)(onHoverOut,hoverProps.onHoverOut),onFocus:(0,mergeRefs/* composeEventHandlers */.M)((0,mergeRefs/* composeEventHandlers */.M)(onFocus,focusProps.onFocus),focusRingProps.onFocus),onBlur:(0,mergeRefs/* composeEventHandlers */.M)((0,mergeRefs/* composeEventHandlers */.M)(onBlur,focusProps.onBlur),focusRingProps.onBlur)},resolvedProps,{accessibilityRole:(_props$accessibilityR=props.accessibilityRole)!==null&&_props$accessibilityR!==void 0?_props$accessibilityR:"button"}),react.createElement(HStack/* default */.Z,_extends({},_stack,{test:true}),startIcon&&!isLoading?startIcon:null,isLoading&&spinnerPlacement==="start"?spinnerElement:null,isLoading?isLoadingText?boxChildren(isLoadingText):null:boxChildren(children),endIcon&&!isLoading?endIcon:null,isLoading&&spinnerPlacement==="end"?spinnerElement:null));};/* harmony default export */ var Button_Button = ((0,react.memo)((0,react.forwardRef)(Button)));
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(76308);
;// CONCATENATED MODULE: ../../node_modules/native-base/lib/module/components/primitives/Button/ButtonGroup.js
var ButtonGroup_excluded=["children","divider","variant"],ButtonGroup_excluded2=["space","direction","size","colorScheme","isDisabled","isAttached"];function ButtonGroup_ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function ButtonGroup_objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ButtonGroup_ownKeys(Object(source),!0).forEach(function(key){(0,defineProperty/* default */.Z)(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ButtonGroup_ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function ButtonGroup_extends(){ButtonGroup_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return ButtonGroup_extends.apply(this,arguments);}/* harmony default export */ var ButtonGroup = ((0,react.memo)((0,react.forwardRef)(function(param,ref){var children=param.children,divider=param.divider,variant=param.variant,props=(0,objectWithoutProperties/* default */.Z)(param,ButtonGroup_excluded);var _usePropsResolution=(0,usePropsResolution/* usePropsResolution */.n)("ButtonGroup",props),space=_usePropsResolution.space,direction=_usePropsResolution.direction,size=_usePropsResolution.size,colorScheme=_usePropsResolution.colorScheme,isDisabled=_usePropsResolution.isDisabled,isAttached=_usePropsResolution.isAttached,newProps=(0,objectWithoutProperties/* default */.Z)(_usePropsResolution,ButtonGroup_excluded2);var _usePropsResolution2=(0,usePropsResolution/* usePropsResolution */.n)("Button",props),borderRadius=_usePropsResolution2.borderRadius;var computedChildren;if(Array.isArray(children)){computedChildren=react.Children.toArray(children).map(function(child,index){if(typeof child==="string"||typeof child==="number")return child;return react.cloneElement(child,ButtonGroup_objectSpread(ButtonGroup_objectSpread(ButtonGroup_objectSpread(ButtonGroup_objectSpread(ButtonGroup_objectSpread({key:"button-group-child-".concat(index),variant:variant,size:size,colorScheme:colorScheme,isDisabled:isDisabled},isAttached?{borderRadius:0}:{}),isAttached&&index===0?direction==="column"?{borderTopRadius:borderRadius}:{borderLeftRadius:borderRadius}:{}),isAttached&&index===(children===null||children===void 0?void 0:children.length)-1?direction==="column"?{borderBottomRadius:borderRadius}:{borderRightRadius:borderRadius}:{}),isAttached&&index!==0?direction==="column"?{borderTopWidth:0}:{borderLeftWidth:0}:{}),child.props));});}else{computedChildren=react.Children.toArray(children).map(function(child,index){return react.cloneElement(child,ButtonGroup_objectSpread({key:"button-group-child-".concat(index),variant:variant,size:size,colorScheme:colorScheme,isDisabled:isDisabled},child.props));});}if((0,useHasResponsiveProps/* useHasResponsiveProps */.M)(props)){return null;}return react.createElement(Stack/* default */.Z,ButtonGroup_extends({divider:divider,space:isAttached?0:space,direction:direction},newProps,{ref:ref}),computedChildren);})));
;// CONCATENATED MODULE: ../../node_modules/native-base/lib/module/components/primitives/Button/index.js
var ButtonTemp=Button_Button;ButtonTemp.Group=ButtonGroup;var primitives_Button_Button=ButtonTemp;

/***/ }),

/***/ 57787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59740);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_native_web_dist_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67196);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82075);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41580);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2626);
/* harmony import */ var _hooks_useHasResponsiveProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87166);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80233);
var _excluded=["color","size","style","testID"];var Spinner=function Spinner(props,ref){var _usePropsResolution=(0,_hooks__WEBPACK_IMPORTED_MODULE_1__/* .usePropsResolution */ .n)("Spinner",props),color=_usePropsResolution.color,size=_usePropsResolution.size,style=_usePropsResolution.style,testID=_usePropsResolution.testID,resolvedProps=(0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_usePropsResolution,_excluded);var resolvedColor=(0,_theme__WEBPACK_IMPORTED_MODULE_3__/* .getColor */ .Lq)(color,(0,_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .F)().colors,(0,_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .F)());var resolvedStyle=(0,_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useStyledSystemPropsResolver */ .t)(resolvedProps);if((0,_hooks_useHasResponsiveProps__WEBPACK_IMPORTED_MODULE_6__/* .useHasResponsiveProps */ .M)(props)){return null;}return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_native_web_dist_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,{testID:testID,accessible:true,accessibilityLabel:"loading",color:resolvedColor,ref:ref,size:size,style:[resolvedStyle,style]});};/* harmony default export */ __webpack_exports__["Z"] = ((0,react__WEBPACK_IMPORTED_MODULE_0__.memo)((0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Spinner)));

/***/ }),

/***/ 7379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useBreakpointValue; }
/* harmony export */ });
/* harmony import */ var react_native_web_dist_exports_useWindowDimensions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55523);
/* harmony import */ var _theme_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17378);
/* harmony import */ var _hooks_useTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80233);
function useBreakpointValue(values){var _useWindowDimensions;var windowWidth=(_useWindowDimensions=(0,react_native_web_dist_exports_useWindowDimensions__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)())===null||_useWindowDimensions===void 0?void 0:_useWindowDimensions.width;var theme=(0,_hooks_useTheme__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .F)();if((0,_theme_tools__WEBPACK_IMPORTED_MODULE_2__/* .hasValidBreakpointFormat */ .b$)(values,theme.breakpoints)){var currentBreakpoint=(0,_theme_tools__WEBPACK_IMPORTED_MODULE_2__/* .getClosestBreakpoint */ .Zn)(theme.breakpoints,windowWidth);return (0,_theme_tools__WEBPACK_IMPORTED_MODULE_2__/* .findLastValidBreakpoint */ .CQ)(values,theme.breakpoints,currentBreakpoint);}else{return values;}}

/***/ }),

/***/ 67196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7896);
/* harmony import */ var _babel_runtime_helpers_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31461);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _StyleSheet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82399);
/* harmony import */ var _View__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62934);
var _excluded=["animating","color","hidesWhenStopped","size","style"];var createSvgCircle=function createSvgCircle(style){return react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle",{cx:"16",cy:"16",fill:"none",r:"14",strokeWidth:"4",style:style});};var ActivityIndicator=react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function(props,forwardedRef){var _props$animating=props.animating,animating=_props$animating===void 0?true:_props$animating,_props$color=props.color,color=_props$color===void 0?"#1976D2":_props$color,_props$hidesWhenStopp=props.hidesWhenStopped,hidesWhenStopped=_props$hidesWhenStopp===void 0?true:_props$hidesWhenStopp,_props$size=props.size,size=_props$size===void 0?"small":_props$size,style=props.style,other=(0,_babel_runtime_helpers_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props,_excluded);var svg=react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",{height:"100%",viewBox:"0 0 32 32",width:"100%"},createSvgCircle({stroke:color,opacity:0.2}),createSvgCircle({stroke:color,strokeDasharray:80,strokeDashoffset:60}));return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_View__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,(0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({},other,{accessibilityRole:"progressbar",accessibilityValueMax:1,accessibilityValueMin:0,ref:forwardedRef,style:[styles.container,style]}),react__WEBPACK_IMPORTED_MODULE_0__.createElement(_View__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,{children:svg,style:[typeof size==="number"?{height:size,width:size}:indicatorSizes[size],styles.animation,!animating&&styles.animationPause,!animating&&hidesWhenStopped&&styles.hidesWhenStopped]}));});ActivityIndicator.displayName="ActivityIndicator";var styles=_StyleSheet__WEBPACK_IMPORTED_MODULE_4__/* ["default"].create */ .Z.create({container:{alignItems:"center",justifyContent:"center"},hidesWhenStopped:{visibility:"hidden"},animation:{animationDuration:"0.75s",animationKeyframes:[{"0%":{transform:[{rotate:"0deg"}]},"100%":{transform:[{rotate:"360deg"}]}}],animationTimingFunction:"linear",animationIterationCount:"infinite"},animationPause:{animationPlayState:"paused"}});var indicatorSizes=_StyleSheet__WEBPACK_IMPORTED_MODULE_4__/* ["default"].create */ .Z.create({small:{width:20,height:20},large:{width:36,height:36}});/* harmony default export */ __webpack_exports__["Z"] = (ActivityIndicator);

/***/ }),

/***/ 96258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7896);
/* harmony import */ var _babel_runtime_helpers_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31461);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _modules_useMergeRefs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50445);
/* harmony import */ var _modules_usePressEvents__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43576);
/* harmony import */ var _StyleSheet__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82399);
/* harmony import */ var _View__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62934);
var _excluded=["activeOpacity","delayPressIn","delayPressOut","delayLongPress","disabled","focusable","onLongPress","onPress","onPressIn","onPressOut","rejectResponderTermination","style"];function TouchableOpacity(props,forwardedRef){var activeOpacity=props.activeOpacity,delayPressIn=props.delayPressIn,delayPressOut=props.delayPressOut,delayLongPress=props.delayLongPress,disabled=props.disabled,focusable=props.focusable,onLongPress=props.onLongPress,onPress=props.onPress,onPressIn=props.onPressIn,onPressOut=props.onPressOut,rejectResponderTermination=props.rejectResponderTermination,style=props.style,rest=(0,_babel_runtime_helpers_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props,_excluded);var hostRef=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);var setRef=(0,_modules_useMergeRefs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(forwardedRef,hostRef);var _useState=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("0s"),duration=_useState[0],setDuration=_useState[1];var _useState2=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),opacityOverride=_useState2[0],setOpacityOverride=_useState2[1];var setOpacityTo=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(value,duration){setOpacityOverride(value);setDuration(duration?duration/1000+"s":"0s");},[setOpacityOverride,setDuration]);var setOpacityActive=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(duration){setOpacityTo(activeOpacity!==null&&activeOpacity!==void 0?activeOpacity:0.2,duration);},[activeOpacity,setOpacityTo]);var setOpacityInactive=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(duration){setOpacityTo(null,duration);},[setOpacityTo]);var pressConfig=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function(){return{cancelable:!rejectResponderTermination,disabled:disabled,delayLongPress:delayLongPress,delayPressStart:delayPressIn,delayPressEnd:delayPressOut,onLongPress:onLongPress,onPress:onPress,onPressStart:function onPressStart(event){var isGrant=event.dispatchConfig!=null?event.dispatchConfig.registrationName==="onResponderGrant":event.type==="keydown";setOpacityActive(isGrant?0:150);if(onPressIn!=null){onPressIn(event);}},onPressEnd:function onPressEnd(event){setOpacityInactive(250);if(onPressOut!=null){onPressOut(event);}}};},[delayLongPress,delayPressIn,delayPressOut,disabled,onLongPress,onPress,onPressIn,onPressOut,rejectResponderTermination,setOpacityActive,setOpacityInactive]);var pressEventHandlers=(0,_modules_usePressEvents__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(hostRef,pressConfig);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_View__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,(0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({},rest,pressEventHandlers,{accessibilityDisabled:disabled,focusable:!disabled&&focusable!==false,pointerEvents:disabled?"none":undefined,ref:setRef,style:[styles.root,!disabled&&styles.actionable,style,opacityOverride!=null&&{opacity:opacityOverride},{transitionDuration:duration}]}));}var styles=_StyleSheet__WEBPACK_IMPORTED_MODULE_6__/* ["default"].create */ .Z.create({root:{transitionProperty:"opacity",transitionDuration:"0.15s",userSelect:"none"},actionable:{cursor:"pointer",touchAction:"manipulation"}});var MemoedTouchableOpacity=react__WEBPACK_IMPORTED_MODULE_0__.memo(react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(TouchableOpacity));MemoedTouchableOpacity.displayName="TouchableOpacity";/* harmony default export */ __webpack_exports__["Z"] = (MemoedTouchableOpacity);

/***/ }),

/***/ 72448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29798);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
"use client";



/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), 'Error'));

/***/ }),

/***/ 3372:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comprehensive-learning-diagnosis",
      function () {
        return __webpack_require__(2858);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/arrow_left_mo.661eb701.png","height":176,"width":174,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAcklEQVR42mNgYPjPyIAAEO5tvj/RP/2bWBgYGBgYfjIxMHxvfXfh89mvaQwM/5kZGBiyub6vunzm2ZlvfQwM/5gYHjEzMDwO+7zz08ZbNhD1DAmsDGwrlafLMrBMgZgyk3EuKwMzA8sKVgYEeML0EGo5AJTYJAk6lvXCAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 4698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/arrow_right_mo.987610e4.png","height":176,"width":174,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAcUlEQVR42mNABv8ZGSCgmeWn/5+o23xgof/MDAxf0z6ffXfheysDww8mhj/MDAzf+p6duXzm+6psLgawGMMtm48bP+98HMbA8JKZgYFhKgsDy3TZlcoMbAmsDBCwnJWBhYF5LutkRgYGKHjE+IQJwgIAfyMkB+mzeKEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 4499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/checkbox_round.eccc91dd.svg","height":46,"width":45});

/***/ }),

/***/ 85124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/ic_file-plus-line.9061b692.svg","height":24,"width":24});

/***/ }),

/***/ 22031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/img_mockup_01.3c57a5a5.png","height":1800,"width":1153,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAAkklEQVR42h2JSwoCQQwFk3T3gLoRBl2IG/cuPIH39DSC4nKu4AH8ocy30z2JYQoK3qMQjOf7d4ycyyK4TxH8FS63at92fRoiq9k8Xt8Ndf1QMjOBjuAIRRUKryIqCiaCZAuOhGQUVMsxM6iBCEqAgMY0rE2H6qYj78gvZnMI3gVOObvt7hDXq+W9btpz5HTKKVV/u9pWHzaN0TEAAAAASUVORK5CYII=","blurWidth":5,"blurHeight":8});

/***/ }),

/***/ 43661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/img_mockup_02.e033994b.png","height":1800,"width":1154,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAAlElEQVR42h2NOw7CQBBDPTNhQ4kEaRANNRUX4JwcBwFtjsABkPiJJGS/syy8wi5sy4TC/fneWRfm09o8QvAnHM/tZviMfnQuW+f76+215G4YFgCkNhMIsyLDcBF1pZViguYMEJR9CCQiqCpBijFrSZiZqBJRFExtQATicsJJdfJbpvT3KKv11jXN7NL1w8Fat48htF8zA1UAVYiFkQAAAABJRU5ErkJggg==","blurWidth":5,"blurHeight":8});

/***/ }),

/***/ 67413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/img_mockup_03.4fd8a327.png","height":1800,"width":1153,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAAlklEQVR42h3KQQ6CMBBG4X+mLYJ0R+ICr+AZvJCXNNElcU08gCYuCEGiLbQdG9/qLT5CbhjfR+fXpjB6kBQvOF+7w+fr1hCieL/Mz9fQau9845xjxQSldAKo4EyEiMRogxgjCEh5FU1hBhag4lI0K/n70mzEKA0mRhIhHueJa7XVWUGSGIEE3d36ft/uTrauKmvtHcDjB2m4RglRvdUfAAAAAElFTkSuQmCC","blurWidth":5,"blurHeight":8});

/***/ }),

/***/ 18967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/img_mockup_04.8bf1338a.png","height":1800,"width":1154,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAAnElEQVR42g3KSwrCMBAA0Jl8qygIikVRL6Bn8JweRxDBjeAFunUhWFtJm6amM+atHzIzfGp3DH2cZ1aXzjUXuN4e+7Ks+tZ33IXevd71WlXVd5FlVmojARkpMWKEhhx5LsITiBgSUnVocCLHMLNTwCFdRFbGavS+IzsYKaQArRSKtvWCGTQxQVqaiKLMt4ew2yyLX4znEPrTKp/f/zhWVFeC5sm9AAAAAElFTkSuQmCC","blurWidth":5,"blurHeight":8});

/***/ }),

/***/ 97407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/img_mockup_05.4e2688b1.png","height":1800,"width":1154,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAAkklEQVR42hWLMQ7CMBAE985OaCmCkKChpuEFPJTfgKDMF3gAUhSBiJP4Yt9hdjXTDaGs6z/nKKlZ1VXPRHfcHu1xCJPMUSzKEl7de89hnBrNiWEKFHnna5ZlUYDMsYNmtVzkNSnBA+oMXE4K8+yY2MgKAJMRE/EQRjZD9c9zynVWTW53OMXtZv38DuN1muNFRNof+ZRUBotSDB8AAAAASUVORK5CYII=","blurWidth":5,"blurHeight":8});

/***/ }),

/***/ 43470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/img_mockup_06.85d58d5a.png","height":1800,"width":1154,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAAlklEQVR42g2OvQrCQBCEd/c2R1oxpAhprG18Ap/Tt1G0FB/BXgRNoeF+crebHRgYvilmEEyf6XdMedn6hr8hhhucr/d9iIZK1ZTz//WeBgohdqUWB1DBkRNC8mxApIgKK9SawTEJ5bwgM4P3HkREVUHJACKhWIa2ba2oyCklsoEGEUzYmIsbd4fUd5vnPIeLfTiNQ/9YAfRyU3raLtZfAAAAAElFTkSuQmCC","blurWidth":5,"blurHeight":8});

/***/ }),

/***/ 84368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/img_mockup_07.436b3b60.png","height":1800,"width":1154,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAAkklEQVR42h3NvQ3CMBQE4LP94lBShApR0FKxAIOyDQLRwQgsACIC2Q7+f1j5dMXpmhNonuPnEHwaFr0eSakLztf7zrgpTj/PPkT3en/X0lg3oFZJSgDMFRCaapNyZjTc0nVUKacstNboSaEAMC4wQcxYEgGVGYCQ7UCWUjrGvOnWs9ps92E1LB/G2pP38ZhSuv0B5yZTAfzJxtMAAAAASUVORK5CYII=","blurWidth":5,"blurHeight":8});

/***/ }),

/***/ 71409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/img_mockup_08.20b8cf63.png","height":1800,"width":1154,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAAlUlEQVR42hWLOw7CMBBE1xs7EBdIfCoKGkoqLsA5OU6klIgjcACE+AhCsNf2LpuRZjSveAY09+f7EGJeTmr7QAMdtN1p9wuRUkqi219vrzUOQ1gloopLUUfYOlsjCyuzCGh0RrAiYgoz6AdEEIMoWEoxvpmy9w2oCqxsQyCknB0SqW+cNleb7T4u5rPLp/+2MdKRKJ7/inlaHiFxDEYAAAAASUVORK5CYII=","blurWidth":5,"blurHeight":8});

/***/ }),

/***/ 7027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/img_mockup_09.7ef30ce2.png","height":1800,"width":1154,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAAlElEQVR42hWNMQ4CMQwEHTu5IyXSIYprqGl4AQ/lNwhEB0/gByhChFwuCdiYaexdrXYNKOEZ93muw6J3gZnPcLrctjGlmqYsuZT0CK/RxncaQAD73ukBVjorItxqE0IDSCSIyFhrM/qA9x40AKoFjUKWRAFCEuuswSnPqIZj5n9nx1/+0LjZlfVqedf1Y87l0Fq7/gCCzlkoDGlaWQAAAABJRU5ErkJggg==","blurWidth":5,"blurHeight":8});

/***/ }),

/***/ 65096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/img_mockup_10.f633dc11.png","height":1800,"width":1154,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAAlklEQVR42hWMOwoCQRBE+7MzuqEoCpqYG3gDz+lxhA3FIxiLgSu47ux8ux0LigqK9xBqXu/PyYe0nM9Mr6IdXLrrwU0+5lI0hPh9PPstjW5alVIYQYGIpNY2lZYYozIhEDeAhEKTD2ithbZtQaoipaTUMNUTBSpujAFmRnLOk6gaVYD/ikjm3f4YNuvFfRjGS1Wdc863H2tMUzVM4+luAAAAAElFTkSuQmCC","blurWidth":5,"blurHeight":8});

/***/ }),

/***/ 98034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/img_mockup_11.f82fd7e2.png","height":1800,"width":1154,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAAlUlEQVR42hWNOw7CMBBE12s7pqQINGmoqbgAB+U0IOgQV6BHCBEJJU7Wn102U8xo9DQaA6pP/zsS5XYV/FdYbnC+3vdxmlMpVYjS+Hr3nRvG2IoIWougyTpsnBonIvHOAhgjKsZ5JhNCAO89CAuwGmoxvGCugIjirDMY44QKPTNAqbVRXmy3O9B2s34OQ7zo+ynn/PgDoKVeHJflTowAAAAASUVORK5CYII=","blurWidth":5,"blurHeight":8});

/***/ }),

/***/ 44798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/img_mockup_12.edfbe67f.png","height":1800,"width":1154,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAAqUlEQVR42g2MOwrCQBBAZzYbswiSIsEiQbAXvIFeQKxsxJN5GpHESvAIdn7wk4ghiZvfjNs+3nvIzJB8srmuWk85dto2TQy76DjRuqq7jriqm/z+TANpgK+1thAZAC0Chp4UAklIycQIQARCCJJZluPtcjUCAUlgd+CzLMoSo/hA7+Rh9QMXFrMlSuUosV5tbKUcU7P9Sr6tFY6nle+5Z7PZF+VvOwqHpz/blVYqJX4EAQAAAABJRU5ErkJggg==","blurWidth":5,"blurHeight":8});

/***/ }),

/***/ 42003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/mobile_consultunt_img_01.b4a59280.svg","height":140,"width":300});

/***/ }),

/***/ 44641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/mobile_consultunt_img_02.273c4bb9.svg","height":140,"width":300});

/***/ }),

/***/ 65771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/mobile_consultunt_img_03.adb4bd31.svg","height":140,"width":300});

/***/ }),

/***/ 46268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/mobile_consultunt_img_04.317d1cde.svg","height":140,"width":300});

/***/ }),

/***/ 20768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/mobile_img_main_01.6d285bfc.png","height":700,"width":781,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAA2klEQVR42mMQl1UzsrJzKXRw8cy3dXTPt3PyKFPTNvZlAAJ9CxdmBkU1vX4vv+D/gSGR/0IiYv4HhUb9l1ZQP8QAAzIysmLCMhoJprYeu+3d/HdaOXrvc3APXOzgGVqta+FuwQAGohaqQZEp/5Iyij7FpuR9Skwv/OLiE/Ffw9i5noFTSM7QxsFtnrOH3z57Z6+DDi7eh9R0TPfySmu52Tp7cTFwCctFunn6/w8Oi/4VGBr1KyQi9o+FjdMfBgYGFbDpZmZmrEBKFYi1gFgTSqu4eweyMDAwMAAA7oA8IjzHOkgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 89369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/pc_consultunt_img_01.9ac08241.svg","height":140,"width":480});

/***/ }),

/***/ 70860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/pc_consultunt_img_02.4d1b118b.svg","height":140,"width":480});

/***/ }),

/***/ 4491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/pc_consultunt_img_03.c75ae005.svg","height":140,"width":480});

/***/ }),

/***/ 33770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/pc_consultunt_img_04.01e521eb.svg","height":140,"width":480});

/***/ }),

/***/ 96046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/pc_img_main_01.76b4bf53.png","height":700,"width":1840,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAZElEQVR42mPQN7Yy9/ILXuvm5b/ExNKxJygqTd4nOE7dyTtcXdvMjZeBU1Cay8HFM8/Z3WeRu0/o/4DwhLuuvhG7bF0Dj+mYu1owgICZlYMF0JQZHj4Bk0UkFU0ZIICZgYGBAQBlthh/MesP/gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 2858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ comprehensive_learning_diagnosis; }
});

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Box/index.js + 2 modules
var Box = __webpack_require__(4934);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/basic/ScrollView/ScrollView.js
var ScrollView = __webpack_require__(7676);
// EXTERNAL MODULE: ./src/components/main/sections/Footer.tsx + 3 modules
var Footer = __webpack_require__(29049);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/app/features/main/components/Header.tsx
var Header = __webpack_require__(90208);
// EXTERNAL MODULE: ../../packages/app/colors/index.tsx
var colors = __webpack_require__(8521);
// EXTERNAL MODULE: ../../packages/app/features/component/svg.tsx
var svg = __webpack_require__(60092);
// EXTERNAL MODULE: ../../packages/app/hooks/useCommonResponsiveValues.ts
var useCommonResponsiveValues = __webpack_require__(89688);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/hooks/useBreakpointValue.js
var useBreakpointValue = __webpack_require__(7379);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Stack/VStack.js
var VStack = __webpack_require__(67974);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Text/index.js
var Text = __webpack_require__(80775);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(76308);
;// CONCATENATED MODULE: ../../packages/app/features/main/sub-page/components/comprehensive-learning-diagnosis/IntroSection1.tsx





const IntroSection1 = (param)=>{
    let { heroRef  } = param;
    const { containerWidth  } = (0,useCommonResponsiveValues/* default */.Z)();
    const textSizeProp = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: {
            size: "h6/600"
        },
        lg: {
            fontSize: "36px",
            fontWeight: 600,
            lineHeight: "60px"
        }
    });
    const imgSrc = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: {
            asset: __webpack_require__(20768),
            src: "/main/mobile_img_main_01.png"
        },
        lg: {
            asset: __webpack_require__(96046),
            src: "/main/pc_img_main_01.png"
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        bgColor: "singletons.black",
        alignItems: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
            ref: heroRef,
            alignItems: "center",
            w: "100%",
            py: {
                base: "72px",
                lg: "120px"
            },
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    h: "58px"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    size: (0,useBreakpointValue/* useBreakpointValue */.S)({
                        base: "h3/800",
                        lg: "h2/900/main"
                    }),
                    textAlign: "center",
                    color: colors/* default.white50 */.Z.white50,
                    children: "종합학습진단"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    mt: "24px",
                    ...textSizeProp,
                    textAlign: "center",
                    color: "singletons.white",
                    children: [
                        "제대로 파악해야만 ",
                        containerWidth.endsWith("%") && "\n",
                        "아이의 꿈을 이룰 수 있습니다!",
                        "\n",
                        "정밀한 분석을 위한 96개의 문항으로",
                        " ",
                        containerWidth.endsWith("%") && "\n",
                        "현재 아이의 공부를 파악하고,",
                        "\n",
                        "현실을 가감없이 냉정하게",
                        " ",
                        containerWidth.endsWith("%") && "\n",
                        "결과지에 표현했습니다."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    mt: {
                        base: "20px",
                        lg: "88px"
                    },
                    height: {
                        base: "270px",
                        lg: "280px"
                    },
                    alignItems: "center",
                    zIndex: 10,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* default */.Z, {
                        width: {
                            base: "375px",
                            lg: "920px"
                        },
                        height: {
                            base: "350px",
                            lg: "350px"
                        },
                        src: imgSrc.src,
                        asset: imgSrc.asset
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    zIndex: 1,
                    position: "absolute",
                    top: {
                        base: "580px",
                        lg: "630px"
                    },
                    width: {
                        base: "400px",
                        lg: "936px"
                    },
                    height: {
                        base: "400px",
                        lg: "936px"
                    },
                    borderRadius: {
                        base: "200px",
                        lg: "468px"
                    },
                    bgColor: colors/* default.green500 */.Z.green500
                })
            ]
        })
    });
};
/* harmony default export */ var comprehensive_learning_diagnosis_IntroSection1 = (IntroSection1);

// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Stack/HStack.js
var HStack = __webpack_require__(79305);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Pressable/Pressable.js
var Pressable = __webpack_require__(5621);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/basic/FlatList/FlatList.js
var FlatList = __webpack_require__(15349);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/useWindowDimensions/index.js
var useWindowDimensions = __webpack_require__(55523);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/exports/TouchableOpacity/index.js
var TouchableOpacity = __webpack_require__(96258);
;// CONCATENATED MODULE: ../../packages/app/features/main/components/DiagnosticScreen.tsx





const screenTitleList = [
    "성적 예측",
    "대학 예측",
    "공부 능력치 평가",
    "성향 분석",
    "나에게 맞는 사교육 방법은?",
    "지금 내가 다니는 학원",
    "나는 어디까지 학습이 가능할까?",
    "나에게 딱맞는 과목별 공부법",
    "목표 대학 공부 SPEC",
    "전체 공부 시간 늘리기",
    "과목별 학습 시간 제안",
    "세부 학습시간 계획표"
];
const screenImageList = [
    {
        asset: __webpack_require__(22031),
        src: "/main/img_mockup_01.png"
    },
    {
        asset: __webpack_require__(43661),
        src: "/main/img_mockup_02.png"
    },
    {
        asset: __webpack_require__(67413),
        src: "/main/img_mockup_03.png"
    },
    {
        asset: __webpack_require__(18967),
        src: "/main/img_mockup_04.png"
    },
    {
        asset: __webpack_require__(97407),
        src: "/main/img_mockup_05.png"
    },
    {
        asset: __webpack_require__(43470),
        src: "/main/img_mockup_06.png"
    },
    {
        asset: __webpack_require__(84368),
        src: "/main/img_mockup_07.png"
    },
    {
        asset: __webpack_require__(71409),
        src: "/main/img_mockup_08.png"
    },
    {
        asset: __webpack_require__(7027),
        src: "/main/img_mockup_09.png"
    },
    {
        asset: __webpack_require__(65096),
        src: "/main/img_mockup_10.png"
    },
    {
        asset: __webpack_require__(98034),
        src: "/main/img_mockup_11.png"
    },
    {
        asset: __webpack_require__(44798),
        src: "/main/img_mockup_12.png"
    }
];
const ScreenStaticCarousel = (param)=>{
    let { currentIndex , onPressLeft , onPressRight  } = param;
    var ref, ref1;
    const iconSize = (0,useBreakpointValue/* useBreakpointValue */.S)({
        lg: "88px",
        base: "80px"
    });
    const screenShotSize = (0,useBreakpointValue/* useBreakpointValue */.S)({
        lg: {
            width: "577px",
            height: "900px"
        },
        base: {
            width: "375px",
            height: "585px"
        }
    });
    const { width  } = (0,useWindowDimensions/* default */.Z)();
    const maxWidth = width > 1280 ? "696px" : "480px";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HStack/* default */.Z, {
        maxWidth: maxWidth,
        position: "relative",
        alignItems: "center",
        justifyContent: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* default */.Z, {
                width: screenShotSize.width,
                height: screenShotSize.height,
                asset: (ref = screenImageList[currentIndex]) === null || ref === void 0 ? void 0 : ref.asset,
                src: (ref1 = screenImageList[currentIndex]) === null || ref1 === void 0 ? void 0 : ref1.src
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HStack/* default */.Z, {
                left: 0,
                width: "100%",
                position: "absolute",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TouchableOpacity/* default */.Z, {
                        onPress: ()=>{
                            if (currentIndex !== 0) {
                                onPressLeft();
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* default */.Z, {
                            width: iconSize,
                            height: iconSize,
                            src: "/main/arrow_left_mo.png",
                            asset: __webpack_require__(65218)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TouchableOpacity/* default */.Z, {
                        onPress: ()=>{
                            if (currentIndex !== screenImageList.length - 1) {
                                onPressRight();
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* default */.Z, {
                            width: iconSize,
                            height: iconSize,
                            src: "/main/arrow_right_mo.png",
                            asset: __webpack_require__(4698)
                        })
                    })
                ]
            })
        ]
    });
};
function DiagnosticScreen() {
    const DiagnosticScreenSectionLg = ()=>{
        const [selectedScreenIndex, setSelectedScreenIndex] = (0,react.useState)(0);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HStack/* default */.Z, {
            w: "100%",
            maxWidth: "1280px",
            justifyContent: "center",
            py: "50px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VStack/* default */.Z, {
                    space: "32px",
                    maxWidth: "433px",
                    children: screenTitleList.map((title, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(HStack/* default */.Z, {
                            space: "16px",
                            children: [
                                selectedScreenIndex === index ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* default */.Z, {
                                    width: "45px",
                                    height: "45px",
                                    src: "/main/checkbox_round.svg",
                                    asset: __webpack_require__(4499)
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    width: "45px",
                                    height: "45px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Pressable/* default */.ZP, {
                                    height: "45px",
                                    onPress: ()=>{
                                        setSelectedScreenIndex(index);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: selectedScreenIndex === index ? "h4/800" : "h4/600",
                                        color: selectedScreenIndex === index ? "primary.400" : "gray.400",
                                        children: title
                                    })
                                })
                            ]
                        }, title))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    w: "100%",
                    maxWidth: "167px",
                    flexShrink: 1
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenStaticCarousel, {
                    currentIndex: selectedScreenIndex,
                    onPressLeft: ()=>{
                        setSelectedScreenIndex((v)=>{
                            return v - 1;
                        });
                    },
                    onPressRight: ()=>{
                        setSelectedScreenIndex((v)=>{
                            return v + 1;
                        });
                    }
                })
            ]
        });
    };
    const DiagnosticScreenSectionBase = ()=>{
        const [selectedScreenIndex, setSelectedScreenIndex] = (0,react.useState)(0);
        const flatListRef = (0,react.useRef)(null);
        const onPressLeft = ()=>{
            var // @ts-ignore
            ref;
            const nextIndex = selectedScreenIndex - 1;
            (ref = flatListRef.current) === null || ref === void 0 ? void 0 : ref.scrollToIndex({
                index: nextIndex,
                viewPosition: 0.5
            });
            setSelectedScreenIndex(nextIndex);
        };
        const onPressRight = ()=>{
            var // @ts-ignore
            ref;
            const nextIndex = selectedScreenIndex + 1;
            (ref = flatListRef.current) === null || ref === void 0 ? void 0 : ref.scrollToIndex({
                index: nextIndex,
                viewPosition: 0.5
            });
            setSelectedScreenIndex(nextIndex);
        };
        const onPressTitle = (index)=>{
            var // @ts-ignore
            ref;
            (ref = flatListRef.current) === null || ref === void 0 ? void 0 : ref.scrollToIndex({
                index,
                viewPosition: 0.5
            });
            setSelectedScreenIndex(index);
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HStack/* default */.Z, {
                    zIndex: 10,
                    width: "100%",
                    position: "absolute",
                    pointerEvents: "none",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: "70px",
                            height: "50px",
                            zIndex: 10,
                            display: selectedScreenIndex === 0 ? "none" : "flex",
                            bgColor: {
                                linearGradient: {
                                    colors: [
                                        "#FFFFFFFF",
                                        "#FFFFFF00"
                                    ],
                                    start: [
                                        0,
                                        1
                                    ],
                                    end: [
                                        1,
                                        1
                                    ]
                                }
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: "70px",
                            height: "50px",
                            zIndex: 10,
                            display: selectedScreenIndex === screenImageList.length - 1 ? "none" : "flex",
                            bgColor: {
                                linearGradient: {
                                    colors: [
                                        "#FFFFFF00",
                                        "#FFFFFFFF"
                                    ],
                                    start: [
                                        0,
                                        1
                                    ],
                                    end: [
                                        1,
                                        1
                                    ]
                                }
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatList/* FlatList */.O, {
                    px: "24px",
                    width: "375px",
                    horizontal: true,
                    ref: flatListRef,
                    showsHorizontalScrollIndicator: false,
                    ItemSeparatorComponent: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: "20px"
                        }),
                    data: screenTitleList,
                    renderItem: (param)=>/*#__PURE__*/ {
                        let { item , index  } = param;
                        return (0,jsx_runtime.jsx)(Pressable/* default */.ZP, {
                            onPress: ()=>{
                                onPressTitle(index);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: selectedScreenIndex === index ? "h6/800" : "h6/600",
                                color: selectedScreenIndex === index ? "primary.400" : "gray.300",
                                children: item
                            })
                        });
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenStaticCarousel, {
                    currentIndex: selectedScreenIndex,
                    onPressLeft: onPressLeft,
                    onPressRight: onPressRight
                })
            ]
        });
    };
    // 모바일과 데스크탑의 UI 동작 방식이 달라져서 분리 시킴
    return (0,useBreakpointValue/* useBreakpointValue */.S)({
        lg: DiagnosticScreenSectionLg(),
        base: DiagnosticScreenSectionBase()
    });
}

;// CONCATENATED MODULE: ../../packages/app/features/main/sub-page/components/comprehensive-learning-diagnosis/IntroSection2.tsx



// constant


const IntroSection2 = ()=>{
    const { containerWidth  } = (0,useCommonResponsiveValues/* default */.Z)();
    const text1Props = (0,useBreakpointValue/* useBreakpointValue */.S)({
        lg: {
            fontSize: "50px",
            fontWeight: 900,
            lineHeight: "70px"
        },
        base: {
            size: "h3/800"
        }
    });
    const gap1 = (0,useBreakpointValue/* useBreakpointValue */.S)({
        lg: "60px",
        base: "16px"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        backgroundColor: "singletons.white",
        alignItems: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
            w: containerWidth,
            alignItems: "center",
            py: {
                base: "48px",
                lg: "120px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    px: {
                        base: "16px",
                        lg: "24px"
                    },
                    py: {
                        base: "4px",
                        lg: "8px"
                    },
                    borderRadius: "60px",
                    borderWidth: "2px",
                    borderColor: colors/* default.grey800 */.Z.grey800,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: (0,useBreakpointValue/* useBreakpointValue */.S)({
                            base: "p_s/600",
                            lg: "h5/600"
                        }),
                        children: "현재 아이의 상태를 파악하고 분석한"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    textAlign: "center",
                    mt: {
                        base: "12px",
                        lg: "24px"
                    },
                    ...text1Props,
                    color: colors/* default.black */.Z.black,
                    children: "종합학습진단 결과지"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    height: gap1
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DiagnosticScreen, {})
            ]
        })
    });
};
/* harmony default export */ var comprehensive_learning_diagnosis_IntroSection2 = (IntroSection2);

;// CONCATENATED MODULE: ../../packages/app/features/main/sub-page/components/comprehensive-learning-diagnosis/IntroSection3.tsx





const IntroSection3 = ()=>{
    const { containerWidth  } = (0,useCommonResponsiveValues/* default */.Z)();
    const paddingY = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "48px",
        lg: "120px"
    });
    const textSize2Props = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "h3/800",
        lg: "h2/900"
    });
    const messageList = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: [
            "교과서나 문제집에 모르는 단어가 \n나오면 그냥 넘어가지 않고 \n의미를 찾아보나요?",
            "학교나 학원에서 배운 수업내용을 \n노트에 잘 정리하고 있나요?",
            "학교에서 선생님께서 주시는 자료들을 \n잘 모아 두었고 필요할 때 찾아보나요?",
            "예전에는 잘 못했지만 \n지금은 잘 하는 과목이 있나요?",
            "학교 숙제를 빠짐없이 성실하게 \n잘 제출하고 있나요?",
            "학교의 다양한 행사와 대회에 \n열심히 참여하고 있나요?"
        ],
        lg: [
            "교과서나 문제집에 모르는 단어가 나오면 그냥 넘어가지 않고 의미를 찾아보나요?",
            "학교나 학원에서 배운 수업내용을 노트에 잘 정리하고 있나요?",
            "학교에서 선생님께서 주시는 자료들을 잘 모아 두었고 필요할 때 찾아보나요?",
            "예전에는 잘 못했지만 지금은 잘 하는 과목이 있나요?",
            "학교 숙제를 빠짐없이 성실하게 잘 제출하고 있나요?",
            "학교의 다양한 행사와 대회에 열심히 참여하고 있나요?"
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        bgColor: colors/* default.grey100 */.Z.grey100,
        alignItems: "center",
        py: paddingY,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                px: {
                    base: "16px",
                    lg: "24px"
                },
                py: {
                    base: "4px",
                    lg: "8px"
                },
                borderRadius: "60px",
                borderWidth: "2px",
                borderColor: colors/* default.grey800 */.Z.grey800,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    size: (0,useBreakpointValue/* useBreakpointValue */.S)({
                        base: "p_s/600",
                        lg: "h5/600"
                    }),
                    children: "다양한 교육기관에서 활용하여 검증된"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                h: {
                    base: "12px",
                    lg: "24px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "singletons.black",
                size: textSize2Props,
                textAlign: "center",
                children: "종합학습진단 문항"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                h: {
                    base: "40px",
                    lg: "60px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
                w: containerWidth,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        bgColor: colors/* default.white50 */.Z.white50,
                        borderRadius: "24px",
                        w: {
                            base: "343px",
                            lg: "684px"
                        },
                        h: {
                            base: "588px",
                            lg: "420px"
                        },
                        py: {
                            base: "36px",
                            lg: "36px"
                        },
                        px: {
                            base: "24px",
                            lg: "42px"
                        },
                        style: [
                            {
                                shadowOffset: {
                                    width: 0,
                                    height: 16
                                },
                                shadowOpacity: 0.1,
                                shadowRadius: 24
                            }
                        ],
                        children: [
                            messageList.map((value, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HStack/* default */.Z, {
                                    py: "10px",
                                    alignItems: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                        base: "start",
                                        lg: "center"
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            borderRadius: "4px",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            bgColor: colors/* default.grey700 */.Z.grey700,
                                            width: "24px",
                                            height: "24px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                textAlign: "center",
                                                size: "p_xs/800",
                                                color: colors/* default.white50 */.Z.white50,
                                                children: index + 1
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            ml: "8px",
                                            size: "h7/500",
                                            color: colors/* default.grey700 */.Z.grey700,
                                            children: value
                                        })
                                    ]
                                }, index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                alignItems: "center",
                                mt: "20px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        width: "4px",
                                        height: "4px",
                                        bgColor: colors/* default.grey500 */.Z.grey500,
                                        borderRadius: "2px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        width: "4px",
                                        height: "4px",
                                        bgColor: colors/* default.grey500 */.Z.grey500,
                                        borderRadius: "2px",
                                        mt: "8px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        width: "4px",
                                        height: "4px",
                                        bgColor: colors/* default.grey500 */.Z.grey500,
                                        borderRadius: "2px",
                                        mt: "8px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HStack/* default */.Z, {
                                mt: "20px",
                                justifyContent: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* default */.Z, {
                                        width: "24px",
                                        height: "24px",
                                        asset: __webpack_require__(85124),
                                        src: "/main/ic_file-plus-line.svg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        ml: "10px",
                                        size: "h6/700",
                                        color: colors/* default.green400 */.Z.green400,
                                        children: "추가 88문항"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        height: (0,useBreakpointValue/* useBreakpointValue */.S)({
                            lg: "120px",
                            base: "54px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HStack/* default */.Z, {
                        flexWrap: "wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                mx: {
                                    base: "7px",
                                    lg: "10px"
                                },
                                my: "12px",
                                bgColor: colors/* default.grey900 */.Z.grey900,
                                width: {
                                    base: "168px",
                                    lg: "236px"
                                },
                                height: {
                                    base: "168px",
                                    lg: "236px"
                                },
                                borderRadius: {
                                    base: "84px",
                                    lg: "118px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mt: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "36px",
                                            lg: "48px"
                                        }),
                                        textAlign: "center",
                                        color: colors/* default.green400 */.Z.green400,
                                        size: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "h6/800",
                                            lg: "h5/800"
                                        }),
                                        children: "01"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        mt: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "8px",
                                            lg: "24px"
                                        }),
                                        color: colors/* default.white50 */.Z.white50,
                                        textAlign: "center",
                                        size: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "p_s/700",
                                            lg: "h7/700"
                                        }),
                                        children: [
                                            "학생부 종합전형",
                                            "\n",
                                            "공통 평가요소 체크리스트",
                                            "\n",
                                            "반영"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                mx: {
                                    base: "7px",
                                    lg: "10px"
                                },
                                my: "12px",
                                bgColor: colors/* default.grey900 */.Z.grey900,
                                width: {
                                    base: "168px",
                                    lg: "236px"
                                },
                                height: {
                                    base: "168px",
                                    lg: "236px"
                                },
                                borderRadius: {
                                    base: "84px",
                                    lg: "118px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mt: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "36px",
                                            lg: "48px"
                                        }),
                                        textAlign: "center",
                                        color: colors/* default.green400 */.Z.green400,
                                        size: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "h6/800",
                                            lg: "h5/800"
                                        }),
                                        children: "02"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        mt: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "8px",
                                            lg: "24px"
                                        }),
                                        color: colors/* default.white50 */.Z.white50,
                                        textAlign: "center",
                                        size: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "p_s/700",
                                            lg: "h7/700"
                                        }),
                                        children: [
                                            "국가수준 학업 성취도",
                                            "\n",
                                            "평가결과 반영"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HStack/* default */.Z, {
                        mt: {
                            base: "12px",
                            lg: "0px"
                        },
                        flexWrap: "wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                mx: {
                                    base: "7px",
                                    lg: "10px"
                                },
                                my: "12px",
                                bgColor: colors/* default.grey900 */.Z.grey900,
                                width: {
                                    base: "168px",
                                    lg: "236px"
                                },
                                height: {
                                    base: "168px",
                                    lg: "236px"
                                },
                                borderRadius: {
                                    base: "84px",
                                    lg: "118px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mt: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "36px",
                                            lg: "48px"
                                        }),
                                        textAlign: "center",
                                        color: colors/* default.green400 */.Z.green400,
                                        size: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "h6/800",
                                            lg: "h5/800"
                                        }),
                                        children: "03"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        mt: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "8px",
                                            lg: "24px"
                                        }),
                                        color: colors/* default.white50 */.Z.white50,
                                        textAlign: "center",
                                        size: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "p_s/700",
                                            lg: "h7/700"
                                        }),
                                        children: [
                                            "대학 교육 협회에서 정한",
                                            "\n",
                                            "인재 기준 반영"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                mx: {
                                    base: "7px",
                                    lg: "10px"
                                },
                                my: "12px",
                                bgColor: colors/* default.grey900 */.Z.grey900,
                                width: {
                                    base: "168px",
                                    lg: "236px"
                                },
                                height: {
                                    base: "168px",
                                    lg: "236px"
                                },
                                borderRadius: {
                                    base: "84px",
                                    lg: "118px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mt: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "36px",
                                            lg: "48px"
                                        }),
                                        textAlign: "center",
                                        color: colors/* default.green400 */.Z.green400,
                                        size: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "h6/800",
                                            lg: "h5/800"
                                        }),
                                        children: "04"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        mt: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "8px",
                                            lg: "24px"
                                        }),
                                        color: colors/* default.white50 */.Z.white50,
                                        textAlign: "center",
                                        size: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "p_s/700",
                                            lg: "h7/700"
                                        }),
                                        children: [
                                            "정확도를 높이기 위한",
                                            "\n",
                                            "대학 입시 결과",
                                            "\n",
                                            "30만건 분석"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        height: (0,useBreakpointValue/* useBreakpointValue */.S)({
                            lg: "60px",
                            base: "40px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        color: colors/* default.grey700 */.Z.grey700,
                        textAlign: "center",
                        size: (0,useBreakpointValue/* useBreakpointValue */.S)({
                            base: "p_s/600",
                            lg: "h5/500"
                        }),
                        children: [
                            "위 요소들을 바탕으로 제작된 96개의 평가문항은 ",
                            "\n",
                            "입시에서 우수한 평가를 받을 수 있는",
                            "\n",
                            "내 아이만의 공부 로드맵으로 재탄생됩니다.",
                            "\n"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var comprehensive_learning_diagnosis_IntroSection3 = (IntroSection3);

;// CONCATENATED MODULE: ../../packages/app/features/main/sub-page/components/comprehensive-learning-diagnosis/IntroSection4.tsx





const IntroSection4 = ()=>{
    const { containerWidth  } = (0,useCommonResponsiveValues/* default */.Z)();
    const paddingY = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "48px",
        lg: "120px"
    });
    const textSize2Props = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "h3/800",
        lg: "h2/900"
    });
    const imgSrc1 = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: {
            asset: __webpack_require__(42003),
            src: "/main/mobile_consultunt_img_01.svg"
        },
        lg: {
            asset: __webpack_require__(89369),
            src: "/main/pc_consultunt_img_01.svg"
        }
    });
    const imgSrc2 = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: {
            asset: __webpack_require__(44641),
            src: "/main/mobile_consultunt_img_02.svg"
        },
        lg: {
            asset: __webpack_require__(70860),
            src: "/main/pc_consultunt_img_02.svg"
        }
    });
    const imgSrc3 = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: {
            asset: __webpack_require__(65771),
            src: "/main/mobile_consultunt_img_03.svg"
        },
        lg: {
            asset: __webpack_require__(4491),
            src: "/main/pc_consultunt_img_03.svg"
        }
    });
    const imgSrc4 = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: {
            asset: __webpack_require__(46268),
            src: "/main/mobile_consultunt_img_04.svg"
        },
        lg: {
            asset: __webpack_require__(33770),
            src: "/main/pc_consultunt_img_04.svg"
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        alignItems: "center",
        py: paddingY,
        bgColor: {
            linearGradient: {
                colors: [
                    "#000000cc",
                    "#3D495A"
                ],
                start: [
                    1,
                    0
                ],
                end: [
                    1,
                    1
                ]
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                px: {
                    base: "16px",
                    lg: "24px"
                },
                py: {
                    base: "4px",
                    lg: "8px"
                },
                borderRadius: "60px",
                borderWidth: "2px",
                borderColor: colors/* default.grey300 */.Z.grey300,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    textAlign: "center",
                    color: colors/* default.white50 */.Z.white50,
                    size: (0,useBreakpointValue/* useBreakpointValue */.S)({
                        base: "p_s/600",
                        lg: "h5/600"
                    }),
                    children: "지금 내 아이에게 종합학습진단이 필요한 이유"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                h: {
                    base: "12px",
                    lg: "24px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                color: colors/* default.white50 */.Z.white50,
                size: textSize2Props,
                textAlign: "center",
                children: [
                    "대표 공부 컨설턴트의 ",
                    containerWidth.endsWith("%") && "\n",
                    "한마디"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                h: {
                    base: "40px",
                    lg: "60px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HStack/* default */.Z, {
                alignItems: "center",
                flexWrap: "wrap",
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        w: {
                            base: "300px",
                            lg: "480px"
                        },
                        h: {
                            base: "580px",
                            lg: "484px"
                        },
                        borderRadius: "20px",
                        bgColor: colors/* default.black */.Z.black,
                        mx: "12px",
                        my: {
                            base: "12px",
                            lg: "30px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* default */.Z, {
                                width: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                    base: "300px",
                                    lg: "480px"
                                }),
                                height: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                    base: "140px",
                                    lg: "140px"
                                }),
                                asset: imgSrc1.asset,
                                src: imgSrc1.src
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                py: "32px",
                                px: "26px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: colors/* default.green400 */.Z.green400,
                                        size: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "h6/800",
                                            lg: "h5/800"
                                        }),
                                        children: "01"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        h: "24px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: colors/* default.white50 */.Z.white50,
                                        size: "h7/700",
                                        children: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            lg: "고1 수학 모의고사 4등급 이하의 학생이\n고3 최종 수능에서 1등급으로  역전하는 비율은 고작 2%입니다.",
                                            base: "고1 수학 모의고사 4등급 이하의\n학생이  고3 최종 수능에서 1등급으로  역전하는 비율은 고작 2%입니다."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        h: "24px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: colors/* default.grey500 */.Z.grey500,
                                        size: "p_m/500",
                                        children: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            lg: "공부는 스킬 싸움이 아닙니다. 습관 싸움입니다.\n범위가 기하급수적으로 늘어나는 고등학교 내신과\n수능공부라는 무거운 공을 잡을 수 있는 힘은\n고등학교 진학 전에 길러주어야 합니다.\n초등학교 고학년부터 중학교까지 학기별 공부량과\n과목별 비율까지 세부적으로 제시해 드립니다.",
                                            base: "공부는 스킬 싸움이 아닙니다.\n습관 싸움입니다.\n범위가 기하급수적으로 늘어나는 고등학교 내신과 수능공부라는 무거운 공을 잡을 수 있는 힘은 고등학교 진학 전에 길러주어야 합니다.\n초등학교 고학년부터 중학교까지 학기별 공부량과 과목별 비율까지 세부적으로\n제시해 드립니다."
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        w: {
                            base: "300px",
                            lg: "480px"
                        },
                        h: {
                            base: "580px",
                            lg: "484px"
                        },
                        borderRadius: "20px",
                        bgColor: colors/* default.black */.Z.black,
                        mx: "12px",
                        my: {
                            base: "12px",
                            lg: "30px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* default */.Z, {
                                width: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                    base: "300px",
                                    lg: "480px"
                                }),
                                height: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                    base: "140px",
                                    lg: "140px"
                                }),
                                asset: imgSrc2.asset,
                                src: imgSrc2.src
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                py: "32px",
                                px: "26px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: colors/* default.green400 */.Z.green400,
                                        size: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "h6/800",
                                            lg: "h5/800"
                                        }),
                                        children: "02"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        h: "24px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: colors/* default.white50 */.Z.white50,
                                        size: "h7/700",
                                        children: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            lg: "초3때 8시간의 공부 격차는 고3이 되면서\n12시간의 공부 격차로 벌어집니다.",
                                            base: "초3때 8시간의 공부 격차는\n고3이 되면서 12시간의 공부 격차로\n벌어집니다."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        h: "24px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: colors/* default.grey500 */.Z.grey500,
                                        size: "p_m/500",
                                        children: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            lg: "대학 입시는 현실을 냉정하게 보아야 합니다.\n현재 다니고 있는 학교에서 전교 1등을 한다고 해서\nSKY에 진학할 수 있는 것은 아닙니다. 확률만 높은 것뿐입니다.\n학생의 공부 시간, 학습 가능 범위, 그리고 가장 중요한 학습의 패턴을\n분석한 후 현재 거주하고 있는 지역의 학습 성취도 및\n대학교 입결 결과 등을 반영하여 정교함을 더했습니다.",
                                            base: "대학 입시는 현실을 냉정하게 보아야\n합니다. 현재 다니고 있는 학교에서\n전교 1등을 한다고 해서 SKY에 진학할 수 있는 것은 아닙니다.\n확률만 높은 것뿐입니다. 학생의 공부\n시간, 학습 가능 범위, 그리고 가장 중요한 학습의 패턴을 분석한 후 현재 거주하고 있는 지역의 학습 성취도 및 대학교 입결 결과 등을 반영하여 정교함을 더했습니다."
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HStack/* default */.Z, {
                alignItems: "center",
                flexWrap: "wrap",
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        w: {
                            base: "300px",
                            lg: "480px"
                        },
                        h: {
                            base: "580px",
                            lg: "484px"
                        },
                        borderRadius: "20px",
                        bgColor: colors/* default.black */.Z.black,
                        mx: "12px",
                        my: {
                            base: "12px",
                            lg: "30px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* default */.Z, {
                                width: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                    base: "300px",
                                    lg: "480px"
                                }),
                                height: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                    base: "140px",
                                    lg: "140px"
                                }),
                                asset: imgSrc3.asset,
                                src: imgSrc3.src
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                py: "32px",
                                px: "26px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: colors/* default.green400 */.Z.green400,
                                        size: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "h6/800",
                                            lg: "h5/800"
                                        }),
                                        children: "03"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        h: "24px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: colors/* default.white50 */.Z.white50,
                                        size: "h7/700",
                                        children: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            lg: "특목고 진학 70명인 중학교와, 0명인 중학교의 전교1등은\n완벽히 다르게 정의 내려져야만 합니다!",
                                            base: "특목고 진학 70명인 중학교와,\n0명인 중학교의 전교1등은 완벽히\n다르게 정의 내려져야만 합니다!"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        h: "24px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: colors/* default.grey500 */.Z.grey500,
                                        size: "p_m/500",
                                        children: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            lg: "학생의 공부시간, 학습 가능 범위, 학습 패턴 및 성향을 1차 반영하고\n지역별 학업 성취도를 2차 적용하여 전국 단위에서 학생의 성적을\n분석합니다.\n또한, 현재와 같은 공부 패턴을 유지했을 경우\n중고등학교의 성적까지도 예측합니다.",
                                            base: "학생의 공부시간, 학습 가능 범위, 학습 패턴 및 성향을 1차 반영하고 지역별 학업 성취도를 2차 적용하여 전국 단위에서\n학생의 성적을 분석합니다.\n또한, 현재와 같은 공부 패턴을 유지했을 경우 중고등학교의 성적까지도 예측합니다."
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        w: {
                            base: "300px",
                            lg: "480px"
                        },
                        h: {
                            base: "580px",
                            lg: "484px"
                        },
                        borderRadius: "20px",
                        bgColor: colors/* default.black */.Z.black,
                        mx: "12px",
                        my: {
                            base: "12px",
                            lg: "30px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* default */.Z, {
                                width: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                    base: "300px",
                                    lg: "480px"
                                }),
                                height: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                    base: "140px",
                                    lg: "140px"
                                }),
                                asset: imgSrc4.asset,
                                src: imgSrc4.src
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                py: "32px",
                                px: "26px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: colors/* default.green400 */.Z.green400,
                                        size: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            base: "h6/800",
                                            lg: "h5/800"
                                        }),
                                        children: "04"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        h: "24px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: colors/* default.white50 */.Z.white50,
                                        size: "h7/700",
                                        children: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            lg: "학원은 무조건 다녀야 하는 곳이 아니라\n‘선택’해서 ‘이용’해야 하는 곳입니다!",
                                            base: "학원은 무조건 다녀야 하는 곳이\n아니라 ‘선택’해서 ‘이용’ 해야\n하는 곳입니다!"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        h: "24px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: colors/* default.grey500 */.Z.grey500,
                                        size: "p_m/500",
                                        children: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                            lg: "초~중 과정은 대입의 골격이 정해지는 중요한 시기입니다.\n학원이 ‘그냥‘, ‘잘 가르친다니까’ 다니는 곳이 되면 아이의 소중한 시간과 \n돈만 허비하는 곳이 됩니다.\n학원은 학생의 성향과 상황에 따라 선택해서 이용해야 하는 곳입니다.\n종합진단평가에서는 학생과 학원의 적합도를 분석해\n최적의 대안을 제시해 드립니다.",
                                            base: "초~중 과정은 대입의 골격이 정해지는\n중요한 시기입니다.\n학원이 ‘그냥‘, ‘잘 가르친다니까’\n다니는 곳이 되면 아이의 소중한 시간과\n돈만 허비하는 곳이 됩니다.\n학원은 학생의 성향과 상황에 따라\n선택해서 이용해야 하는 곳입니다.\n종합진단평가에서는 학생과 학원의 적합도를\n분석해 최적의 대안을 제시해 드립니다."
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var comprehensive_learning_diagnosis_IntroSection4 = (IntroSection4);

// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Button/index.js + 2 modules
var Button = __webpack_require__(39388);
// EXTERNAL MODULE: ../../packages/app/features/main/hooks/useRoute.ts
var useRoute = __webpack_require__(80149);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/esm/Error.js
var Error = __webpack_require__(72448);
;// CONCATENATED MODULE: ../../packages/app/features/main/sub-page/components/comprehensive-learning-diagnosis/IntroSection5.tsx







const IntroSection5 = ()=>{
    const { containerWidth  } = (0,useCommonResponsiveValues/* default */.Z)();
    const { routeGeneralFAQ  } = (0,useRoute/* default */.Z)();
    const textSize1 = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "h3/800",
        lg: "h2/900/main"
    });
    const textSize2 = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "p_s/600",
        lg: "h5/500/main"
    });
    const textSize4 = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "h6/700",
        lg: "h5/700"
    });
    const textSize6 = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "p_m/600",
        lg: "h6/600"
    });
    const textSize7 = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "p_m/500",
        lg: "h6/500"
    });
    const buttonWidth = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "343px",
        lg: "475px"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        py: {
            base: "60px",
            lg: "150px"
        },
        bgColor: {
            linearGradient: {
                colors: [
                    "#000000cc",
                    "#28303D"
                ],
                start: [
                    1,
                    0
                ],
                end: [
                    1,
                    1
                ]
            }
        },
        alignItems: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
            px: "16px",
            w: containerWidth,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "singletons.white",
                    size: textSize1,
                    children: "FAQ"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    h: {
                        base: "24px",
                        lg: "32px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "gray.400",
                    size: textSize2,
                    children: "종합학습진단에 대해 더 궁금한게 있으신가요?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    h: {
                        base: "24px",
                        lg: "32px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    variant: "outline",
                    w: buttonWidth,
                    h: "60px",
                    _text: {
                        color: "singletons.white"
                    },
                    bgColor: colors/* default.transparent */.Z.transparent,
                    borderColor: "singletons.white",
                    _hover: {
                        bgColor: "#ffffff1f",
                        borderColor: "singletons.white"
                    },
                    _pressed: {
                        bgColor: "#ffffff1f",
                        borderColor: "singletons.white"
                    },
                    onPress: routeGeneralFAQ,
                    children: "FAQ 바로가기"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    h: {
                        base: "40px",
                        lg: "60px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
                    px: {
                        base: "16px",
                        lg: "40px"
                    },
                    py: "40px",
                    w: "100%",
                    bgColor: "gray.800",
                    borderRadius: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HStack/* default */.Z, {
                            alignItems: "center",
                            space: "10px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* default */.Z, {
                                    color: "primary"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    size: textSize4,
                                    color: "singletons.white",
                                    children: "상품 이용안내"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            h: {
                                base: "24px",
                                lg: "40px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VStack/* default */.Z, {
                            space: "40px",
                            children: ProductGuideList.map((item, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGuideItem, {
                                    item: item,
                                    categoryTextSize: textSize6,
                                    guideTextSize: textSize7
                                }, index);
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var comprehensive_learning_diagnosis_IntroSection5 = (IntroSection5);
const ProductGuideList = [
    {
        category: "종합학습진단 관련",
        guide: [
            "종합학습진단 진행 후 1:1 All Care Pack 상품을 구매하신 경우, 진단결과를 불러올 수 있습니다."
        ]
    },
    {
        category: "중단/환불 정책",
        guide: [
            "종합학습진단 시행 전일 경우, 서비스 이용대금 전액 환불해드립니다.",
            "종합학습진단이 진행 중이거나 완료된 경우, 서비스 이용이 완료된 것으로 간주하여 환불이 불가합니다."
        ]
    },
    {
        category: "결제 정책",
        guide: [
            "상품은 카드결제를 통해 결제 가능합니다.",
            "카드 할부 결제가 가능하며 무이자 할부 개월 수는 각 카드사 및 결제 대행사(PG사) 할부 프로모션에 따라 상이합니다.",
            "무이자 카드 혜택은 고객센터 페이지에서 확인 가능합니다."
        ]
    }
];
const ProductGuideItem = (param)=>{
    let { item , categoryTextSize , guideTextSize  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
            space: "16px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    size: categoryTextSize,
                    color: "singletons.white",
                    children: item.category
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VStack/* default */.Z, {
                    children: item.guide.map((value, idx)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HStack/* default */.Z, {
                                space: "6px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "gray.400",
                                        size: guideTextSize,
                                        children: "•"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "gray.400",
                                        size: guideTextSize,
                                        children: value
                                    })
                                ]
                            })
                        }, idx);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../packages/app/features/main/sub-page/comprehensive-learning-diagnosis/screen.tsx










const Screen = ()=>{
    const heroRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        backgroundColor: "singletons.white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                heroRef: heroRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                position: "absolute",
                h: "300px",
                top: "0",
                bgColor: "singletons.black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollView/* ScrollView */.p, {
                bgColor: "singletons.black",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(comprehensive_learning_diagnosis_IntroSection1, {
                        heroRef: heroRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(comprehensive_learning_diagnosis_IntroSection2, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(comprehensive_learning_diagnosis_IntroSection3, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(comprehensive_learning_diagnosis_IntroSection4, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(comprehensive_learning_diagnosis_IntroSection5, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var screen = (Screen);

// EXTERNAL MODULE: ../../packages/core/constants/page-titles.ts
var page_titles = __webpack_require__(55931);
;// CONCATENATED MODULE: ./src/pages/comprehensive-learning-diagnosis/index.tsx






var ComprehensiveLearningDiagnosisPage = function ComprehensiveLearningDiagnosisPage() {
    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (0,jsx_runtime.jsx)((head_default()), {
                children: (0,jsx_runtime.jsx)("title", {
                    children: page_titles/* URL_TITLE_MAP.COMPREHENSIVE_LEARNING_DIAGNOSTICS */.$.COMPREHENSIVE_LEARNING_DIAGNOSTICS
                })
            }),
            (0,jsx_runtime.jsx)(screen, {})
        ]
    });
};
/* harmony default export */ var comprehensive_learning_diagnosis = (ComprehensiveLearningDiagnosisPage);


/***/ }),

/***/ 90208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _apps_next_src_components_main_sections_Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87621);



const Header = (param)=>{
    let { heroRef , isStatic =false  } = param;
    const [isOverflowHeroImage, setIsOverflowHeroImage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isStatic || !(heroRef === null || heroRef === void 0 ? void 0 : heroRef.current)) return;
        const checkOverflowHeroImage = ()=>{
            var ref;
            const scrollY = window.scrollY;
            var ref1;
            const heroY = (ref1 = (ref = heroRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) !== null && ref1 !== void 0 ? ref1 : 0;
            const isOverflowHeroImage = scrollY > heroY;
            setIsOverflowHeroImage(isOverflowHeroImage);
        };
        checkOverflowHeroImage();
        window.addEventListener("scroll", checkOverflowHeroImage);
        return ()=>{
            window.removeEventListener("scroll", checkOverflowHeroImage);
        };
    }, [
        heroRef,
        setIsOverflowHeroImage,
        isStatic
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_apps_next_src_components_main_sections_Header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        isOverflowHeroImage: isOverflowHeroImage,
        headerBgColor: isOverflowHeroImage ? "bg-singletons-white" : "bg-singletons-black",
        titleTextColor: isOverflowHeroImage || isStatic ? "text-singletons-black" : "text-singletons-white"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Header);


/***/ }),

/***/ 89688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var native_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7379);

const useCommonResponsiveValues = ()=>{
    const containerWidth = (0,native_base__WEBPACK_IMPORTED_MODULE_0__/* .useBreakpointValue */ .S)({
        base: "100%",
        lg: "992px",
        xl: "1280px"
    });
    return {
        containerWidth
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCommonResponsiveValues);


/***/ }),

/***/ 55931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ URL_TITLE_MAP; }
/* harmony export */ });
/* harmony import */ var _is_hicampus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73018);

// https://docs.google.com/spreadsheets/d/1Z3LH-hzo37fGRMSkHrOTfBQC8lnt_N0b-3yizfSFx4I/edit#gid=0
// https://docs.google.com/spreadsheets/d/1UJe8BqquNyHfucJFz8hoEJ-zzOPeYOa8cSY2HYqj_q4/edit?gid=0#gid=0
const URL_TITLE_MAP = {
    // '/login'
    LOGIN: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 로그인" : "브릿지 프로젝트 - 로그인",
    // '/auth/agreement'
    AUTH_AGREEMENT: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜" : "브릿지 프로젝트",
    // '/comprehensive-learning-diagnosis/'
    COMPREHENSIVE_LEARNING_DIAGNOSTICS: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 종합학습진단" : "브릿지 프로젝트 - 종합학습진단",
    // '/premium-1on1-consulting-service/'
    ONE_ON_ONE_CONSULTING: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 1:1 공부 컨설팅" : "브릿지 프로젝트 - 1:1 공부 컨설팅",
    // '/all-care-pack/'
    ALL_CARE_PACK: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 1:1 All Care Pack" : "브릿지 프로젝트 - 1:1 All Care Pack",
    // '/pricing/'
    PRICING: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 상품안내" : "브릿지 프로젝트 - 상품안내",
    // '/promotion/whitepencil/'
    PROMOTION_WHITE_PENCIL: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 화이트 펜슬 제휴" : "브릿지 프로젝트 - 화이트 펜슬 제휴",
    // '/event/'
    EVENT: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 이벤트" : "브릿지 프로젝트 - 이벤트",
    // '/tab-bar/?path=home'
    HOME: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 학습홈" : "브릿지 프로젝트 - 학습홈",
    // '/tab-bar/?path=calendar'
    CALENDAR: "홈 - 공부 달력",
    // '/tab-bar/?path=report'
    REPORT: "홈 - 리포트",
    // '/tab-bar/?path=my-page'
    MY_PAGE: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 마이페이지" : "홈 - 마이페이지",
    // '/?path=diagnosticResult'
    HOME_DIAGNOSTIC_RESULT: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 학습 전략 진단 내역" : "홈 - 학습 전략 진단 내역",
    // '/?path=consulting'
    HOME_CONSULTING: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 컨설팅 내역" : "홈 - 컨설팅 내역",
    // '/calendar/study-plan/?date='
    CALENDAR_STUDY_PLAN: "공부 달력 - 공부 계획",
    // '/calendar/study-plan/guide'
    CALENDAR_STUDY_PLAN_GUIDE: "공부 달력 - 공부 계획 - 가이드",
    // '/calendar/study-plan-detail/?planId='
    STUDY_PLAN_DETAIL: "공부 달력 - 공부 계획 상세",
    // '/report/detail/daily/?id='
    REPORT_DAILY: "리포트 - 일간 리포트",
    // '/report/detail/weekly/?id='
    REPORT_WEEKLY: "리포트 - 주간 리포트",
    // '/diagnostic/diagnostic-list'
    DIAGNOSTIC_LIST: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 학습 전략 진단 내역" : "마이페이지 - 종합학습진단 내역",
    // '/diagnostic/test/?diagnosticSheetId='
    DIAGNOSTIC_TEST: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 학습 전략 진단 응시" : "종합학습진단 응시",
    // '/diagnostic/?resetDiagnosticSheetId='
    DIAGNOSTIC: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 학습 전략 진단 응시" : "종합학습진단 응시",
    // '/diagnostic/result/?diagnosticSheetId='
    DIAGNOSTIC_RESULT: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 학습 전략 진단 결과" : "종합학습진단 결과",
    // '/my-page/parent-connection/'
    MY_PAGE_PARENT_CONNECTION: "마이페이지 - 부모님 연결",
    // '/my-page/study-profile/?isStudent=true'
    MY_PAGE_STUDY_PROFILE: "마이페이지 - 공부현황 점검",
    // '/diagnostic/diagnostic-list/'
    MY_PAGE_DIAGNOSTICS: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 학습 전략 진단 내역" : "마이페이지 - 종합학습진단 내역",
    // '/consulting/reservation/book'
    CONSULTING_RESERVATION_BOOK: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 컨설팅 예약" : "마이페이지 - 컨설팅 예약",
    // '/consulting/reservations/'
    MY_PAGE_CONSULTING_RESERVATIONS: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 컨설팅 내역" : "마이페이지 - 컨설팅 내역",
    // '/consulting/reservations/change/?id='
    CONSULTING_CHANGE_RESERVATION: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 컨설팅 변경" : "마이페이지 - 컨설팅 변경",
    // '/consulting/reservations/detail/?id='
    MY_PAGE_CONSULTING_RESERVATIONS_DETAIL: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 컨설팅 예약 상세" : "마이페이지 - 컨설팅 예약 상세",
    // '/special-lecture/'
    MY_PAGE_SPECIAL_LECTURE: "마이페이지 - 일깨움 특강",
    // '/my-page/setting/'
    MY_PAGE_SETTING: "마이페이지 - 설정",
    // '/billing/payment-history/'
    MY_PAGE_BILLING_PAYMENTS: "마이페이지 - 결제 내역",
    // '/billing/payment-details/?merchantUid'
    MY_PAGE_BILLING_PAYMENT_DETAILS: "결제 내역 - 결제 상세",
    // '/billing/manage-payment/'
    MY_PAGE_BILLING_MANAGE_PAYMENT: "마이페이지 - 결제 수단 관리",
    // '/billing/register-card/?beforeScreen=manage-payment&isChanged=false'
    MY_PAGE_BILLING_REGISTER_CARD: "결제 수단 관리 - 카드 등록",
    // '/my-page/register-coupon/'
    MY_PAGE_REGISTER_COUPON: "마이페이지 - 코드 등록",
    // '/my-page/inquiry/'
    MY_PAGE_INQUIRY: "마이페이지 - 1:1 문의",
    // '/my-page/request-inquiry/'
    MY_PAGE_REQUEST_INQUIRY: "1:1 문의 - 문의하기",
    // '/my-page/inquiry-detail/?inquiryId='
    MY_PAGE_INQUIRY_DETAIL: "1:1 문의 - 문의 내용"
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2038,4942,5621,4192,8686,9774,2888,179], function() { return __webpack_exec__(3372); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);